export const NO_CONNECTION_SNACKBAR_ID = 'NO_CONNECTION';
